import Vue from 'vue'
import App from './App.vue'
import * as PhilaUi from "@phila/phila-ui";
import router from "./router";
import store from "./store";
import VueSimpleAlert from "vue-simple-alert";
import { ValidationProvider, ValidationObserver, extend} from "vee-validate";
import { required, numeric, email, between } from 'vee-validate/dist/rules';
import { withValidation } from "vee-validate";


Vue.config.productionTip = false


Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

const VeeTextbox = withValidation(PhilaUi.Textbox);
const VeeDropdown = withValidation(PhilaUi.Dropdown);
const VeeTextarea = withValidation(PhilaUi.TextArea);
const VeeRadio = withValidation(PhilaUi.Radio);
const VeeCheckbox = withValidation(PhilaUi.Checkbox);
Vue.use(VueSimpleAlert);
Vue.component("VeeTextbox", VeeTextbox);
Vue.component("VeeDropdown", VeeDropdown);
Vue.component("VeeTextarea", VeeTextarea);
Vue.component('VeeRadio', VeeRadio);
Vue.component('VeeCheckbox', VeeCheckbox);

extend('required', {
  ...required,
  message: 'This field is required',
});
extend("numeric", {
  ...numeric,
  message: "Please enter a number"
});
extend('doubleCurrency', {
  message: 'Please enter a valid amount with 2 decimals (for example: 99.99)',
  validate (value) {
    return new Promise(resolve => {
      const isValid = /^[0-9]*(\.[0-9]{0,2})?$/.test(value);
      resolve({ valid: isValid });
    });
  },
});
extend('numericAMI', {
  message: 'Please enter a number with 3 digits or less that is 120 or less',
  validate (value) {
    return new Promise(resolve => {
      const isValid = /(^\d{1,3})?$/.test(value);
      resolve({ valid: (isValid) });
    });
  },
});
extend('phone', {
  message: 'Please enter a valid phone number (for example: 123-456-7890 or 9876543210)',
  validate (value) {
    return new Promise(resolve => {
      const isValid = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);
      resolve({ valid: isValid });
    });
  },
});
extend('email', {
  ...email,
  message: 'Please enter a valid email address (for example: MyName@MyEmail.com)',
});
extend('year',{
  ...between,
  message: 'Please enter a valid year'
});

Vue.use(PhilaUi);
const isProduction = process.env.NODE_ENV === "production";
Vue.config.productionTip = true;
Vue.config.devtools = !isProduction;



new Vue({
  router,
  store,
  mounted: function() {
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.addEventListener("hashchange", this.hashChangeHandler);
    }
  },
  destroyed: function() {
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.removeEventListener("hashchange", this.hashChangeHandler);
    }
  },
  methods: {
    hashChangeHandler: function() {
      var target = window.location.hash;
      this.$router.push(target.substring(1, target.length));
    }
  },
  render: h => h(App)
}).$mount("#app");

